<template>
  <LcBadge class="prize-badge">
    <template #icon>
      <slot name="outer-value">
        <span
          class="prize-badge-inner flex items-center justify-center bg-secondary-secondary-bold-disabled rounded-s py-025 px-050"
        >
          <slot name="value" />
        </span>
      </slot>
    </template>

    <slot />
  </LcBadge>
</template>

<style lang="scss" scoped>
.prize-badge {
  min-height: 1.75rem;
  padding: token('size/space/gap/025') token('size/space/gap/050');

  &-inner {
    min-width: 1.5rem;
    height: 1.5rem;
  }
}
</style>
